import { PermissionT } from "../types";

export const ticketsView = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "tickets_view");
  return !!p;
};
export default ticketsView;
